import { Any, MetricsEvents, SendEventDtoType } from "@cede/types";
import { randomUuid } from "@cede/utils";
import { mixpanelClient } from "./index";

/**
 * Identity is stamped at flush time, so it is deliberately absent here. `insertId` and
 * `occurredAt` are not: an event may sit in the queue across several failed flushes,
 * and both must survive redelivery unchanged for Mixpanel to dedup it.
 *
 * A leaf on purpose — the hook that consumes it imports `useHubUser`, which tracks
 * events itself, so building the DTO there would close a dependency cycle.
 */
export const buildQueuedEvent = (event: MetricsEvents, properties: Record<string, Any>): SendEventDtoType => ({
  event,
  userId: "",
  insertId: randomUuid(),
  occurredAt: new Date().toISOString(),
  properties: {
    ...mixpanelClient.getClientProperties(),
    ...properties,
  },
});
